import React from 'react';
import { graphql, StaticQuery } from 'gatsby';
import { Navigation, Footer, CopyrightLabel, SiteMap, SocialMedia } from '@fishrmn/fishrmn-components';
import { Link } from 'gatsby';
import 'semantic-ui-less/semantic.less';
import './layout.css';

export default ({ children }) => (
  <StaticQuery
    query={graphql`
      query {
        allFisherman {
          edges {
            node {
                       businessName 
          socialMedia {
            link 
            type 
          }
            }
          }
        }
        allFishermanImages {
          edges {
            node {
              heroImages {
                url
              }
              galleryImages {
                url
              }
            }
          }
        }
      }
    `}
    render={queryData => {
      const businessData = queryData.allFisherman.edges[0].node;
      const imageData = queryData.allFishermanImages.edges[0].node;
      const data = { ...businessData, ...imageData };

      return (
        <div className="site-container">
          <div>
                        <Navigation
               links={ [{"pageTitle":"Home","slug":"/","internal":true},{"pageTitle":"Contact","slug":"/contact/","internal":true},{"pageTitle":"Menu","slug":"https://fisherman-static.s3.amazonaws.com/public/julitosperuvianchicken/julitos_Menu_All_Copies.pdf","internal":false},
               {
                pageTitle: "Order Online",
                slug: "https://ordering.chownow.com/order/22653/locations",
                internal: false,
                className: "chownow-order-online"
              }] }
               backgroundColor={ "white" }
               bordered={ false }
               centerMobileNavItems={ true }
               evenSpacing={ true }
               fixed={ false }
               header={ data.businessName }
               linksAs={ "h4" }
               logo={ false }
               primaryContentCentered={ false }
               internalLinkComponent={Link}
            />
          </div>
          <div className="page-container">{children}</div>
          <Footer
             backgroundColor={ "primary" }
             horizontalAlign={ "center" }
             verticalAlign={ "middle" }
             columns={[
               <CopyrightLabel
                  company={ data.businessName }
                  phrase={ "All Rights Reserved" }
               />,
               <SiteMap
                  links={ [{"pageTitle":"Home","slug":"/","internal":true},{"pageTitle":"Contact","slug":"/contact/","internal":true},{"pageTitle":"Menu","slug":"https://fisherman-static.s3.amazonaws.com/public/julitosperuvianchicken/julitos_Menu_All_Copies.pdf","internal":false},{
                    pageTitle: "Order Online",
                    slug: "https://ordering.chownow.com/order/22653/locations",
                    internal: false,
                    className: "chownow-order-online"
                  }] }
                  horizontal={ true }
                  bulleted={ false }
                  internalLinkComponent={ Link }
               />,
               <SocialMedia
                  socialMediaValues={ data.socialMedia }
                  buttonType={ "circle" }
                  centerHeader={ true }
                  colors={ "secondary" }
                  groupButtons={ false }
                  groupVertically={ false }
                  header={ "" }
                  inverted={ false }
                  labelPosition={ "left" }
                  showLabels={ false }
               />,
             ]}
          />
        </div>
      )
    }}
  />
);